/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Style from './style';
import { getRowConfig } from './config';
import Widget from '../../../../../../Analysis/widget';
import { useState } from 'react';
import { useCallback } from 'react';
import { useEffect } from 'react';
import { DashboardService } from '../../../../../../../services';

export default function KeyIndicators({
  selectedParters = [],
  loading: partnersLoading = false,
}) {
  const { t } = useTranslation();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const config = useMemo(() => getRowConfig(t, data), [t, data]);

  const fetchData = useCallback(async () => {
    if (partnersLoading) {
      return;
    }

    setLoading(true);

    try {
      const { data } = await DashboardService.getIndicators(selectedParters);
      setData(data);
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  }, [selectedParters, partnersLoading]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Widget
      loading={loading || partnersLoading}
      className="with-border-header"
      title={t('Key Indicators')}>
      <Style className='flex'>
        {config.map((c, i) => (
          <div className='row-item' key={`key-indicators-${i}`}>
            <h4>{c.label}</h4>
            <div className='flex'>
              {c.render()}
            </div>
          </div>
        ))}
      </Style>
    </Widget>
  )
}
